import { render } from "./TheUserAntifrodeDetail.vue?vue&type=template&id=1b5118ae"
import script from "./TheUserAntifrodeDetail.vue?vue&type=script&lang=js"
export * from "./TheUserAntifrodeDetail.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__